var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormInput',{attrs:{"label":_vm.texto_documento,"name":`${_vm.texto_documento}${_vm.index > 0 ? (' ' + _vm.index) : ''}`,"rules":{ required: true, identificacion: { tipo: _vm.type } },"value":_vm.value,"disabled":!_vm.type,"id":`valor-documento-${_vm.index}`},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }